module.exports = __webpack_public_path__ + "img/menu-burger.f7bffe36.svg";